import axios from '../../../helpers/AxiosConfig';
import { AddNoteParams, AddNoteResponse } from './suggestion.types';

export const addNote = async (mappingData: AddNoteParams) =>
  axios.post<AddNoteResponse>('suggestion/addNote', { ...mappingData });
